/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */
import axios from 'axios';
import { Auth } from 'aws-amplify';
import { baseURL } from '../config';
import { authHeader } from '../CommonMethods/Auth-Headers';
import { CognitoData, getCurrentUserSession } from "../CommonMethods/CognitoData";
import { NavObj } from '../config/role-based-routing';
import { useNavigate } from 'react-router-dom';
import { GetBranchId } from '../CommonMethods/GetBranchId';

// Function to handle 403 status code
const handleForbiddenError = () => {
    const broadcastChannel = new BroadcastChannel('update-channel')
    broadcastChannel.postMessage({ type: 'access-denied', value: true });
};

const trimBody = (data) => {
    if (Array.isArray(data)) {
        return data.map(item => {
            if (typeof item === 'string') {
                return item.trim();
            } else if (typeof item === 'object' && item !== null) {
                return trimBody(item);
            }
            return item;
        });
    } else if (typeof data === 'object' && data !== null) {
        let trimmedPayload = {};
        for (let key in data) {
            if (typeof data[key] === 'string') {
                trimmedPayload[key] = data[key].trim();
            } else if (Array.isArray(data[key])) {
                trimmedPayload[key] = trimBody(data[key]);
            } else if (typeof data[key] === 'object' && data[key] !== null) {
                trimmedPayload[key] = trimBody(data[key]);
            } else {
                trimmedPayload[key] = data[key];
            }
        }
        return trimmedPayload;
    }
    return data;
};

const CheckUserStatus = async () => {
    let user = true;
    const broadcastChannel = new BroadcastChannel('update-channel')
    const branch_id = await GetBranchId()
    try {
        const user1 = await CognitoData();
        let res = await dataService.GetAPI(`users/${user1.idToken.payload["email"]}${branch_id ? `?branch_id=${branch_id}` : ''}`, true);
        let nav_obj = [];
        let Roles = res?.data?.data?.data?.roles
        let branchName = res?.data?.data?.data?.branch_name
        let branchID = res?.data?.data?.data?.branch_id
        let userType = res?.data?.data?.data?.user_type
        let branches = res?.data?.data?.data?.branches
        let financiaYear = res?.data?.data?.data?.financial_year
        if (user1.idToken.payload['custom:user_type'] !== "institution-admin") {
            Object.values(NavObj[user1.idToken.payload['custom:user_type']]).forEach(element => {
                if (element.name === 'Profile' || 
                    element.name === "Years" ||
                    (element.name === "Institution Users" && Roles?.includes("institution-users"))) {
                    nav_obj.push(element);
                } else if (element.name === 'Branches' && Roles.includes('branches')) {
                    nav_obj.push(element);
                } else if (element.roleKey && Roles?.includes(element.roleKey)) {
                    nav_obj.push(element);
                } else {
                    let filteredChildren = [];
                    if (element.children && Array.isArray(element.children)) {
                        filteredChildren = element.children.filter(child => Roles.includes(child.roleKey));
                    }
                    const filteredObj = { ...element, children: filteredChildren };
                    if (filteredObj.children?.length !== 0) {
                        nav_obj.push(filteredObj);
                    }
                }
            });

            broadcastChannel.postMessage({ 
                "type": 'updated', 
                "sideNavBarObj": nav_obj, 
                "Roles": Roles, 
                "financiaYear" : financiaYear,
                "branch_details": { "name": branchName, "id": branchID },
                ...(userType === 'institution-user' && {
                    "userTypeObj": {
                        userType: userType,
                        branches: branches
                    }
                })
            });
            broadcastChannel.postMessage({ type: 'access-denied', value: false });
        }
        if (!res?.data?.data?.data?.status) {
            // User is deactivated, log out the user
            await Auth.signOut();
            localStorage.clear();
            window.location.reload();
            sessionStorage.setItem("errorMessage", "Your account has been deactivated. Please contact support.");
        }
    } catch (error) {
        if (error.message && error.message.toLowerCase().includes("network")) {
            console.error("Network error occurred. Please check your internet connection.");
        } else {
            await Auth.signOut();
            localStorage.clear();
            sessionStorage.setItem("errorMessage", "Your account has been deactivated. Please contact support.");
            window.location.reload();
        }
    }
    return user;
};


/**
 * This is an asynchronous function that retrieves data from an API endpoint using axios and returns an
 * object with a boolean error value and the retrieved data.
 * @param endpoint - The `endpoint` parameter is a string that represents the specific API endpoint
 * that the function is trying to access. It is concatenated with the `baseURL` variable to form the
 * complete URL for the API request.
 * @returns an object with two properties: "error" and "data". The "error" property is a boolean value
 * indicating whether an error occurred during the API call. The "data" property contains the response
 * data from the API call.
 */
async function GetAPI(endpoint, dontCheckStatus, noTryCatch) {
    let status = true
    if(dontCheckStatus === undefined) status = await CheckUserStatus()
    if(noTryCatch === undefined){
        if(status){
            try{
                const headers = await authHeader()
                const data = await axios.get(`${baseURL}${endpoint}`, {
                    headers: headers,
                });  
                return { error: false, data: data };
            }
            catch(error){
                if (error.response && error.response.status === 403) {
                    handleForbiddenError(); 
                    throw error
                } else {
                    throw error; // Rethrow the error to propagate it
                }
            }
        }
    } else {
        const headers = await authHeader()
        const data = await axios.get(`${baseURL}${endpoint}`, {
            headers: headers,
        });  
        return { error: false, data: data };

    }

}

/**
 * This is an asynchronous function that sends a POST request to an API endpoint with a given payload
 * and authentication headers.
 * @param body - The body parameter is the data that will be sent in the request body of the HTTP POST
 * request. It can be any valid JavaScript object or data type that can be serialized into JSON format.
 * @param endpoint - The endpoint parameter is a string that represents the specific API endpoint that
 * the function will send a POST request to. It is typically a URL that specifies the location of the
 * API resource that the function will interact with.
 * @returns an object with two properties: "error" and "data". The "error" property is a boolean value
 * indicating whether an error occurred during the API call. The "data" property contains the response
 * data from the API call.
 */
async function PostAPI(body, endpoint) {
    const status = await CheckUserStatus()
    if (status) {
        try{
            let trimedpayload = trimBody(body);
            const headers = await authHeader()
            const data = await axios.post(`${baseURL}${endpoint}`, trimedpayload, {
                headers: headers,
            });
            return { error: false, data: data };
        }
        catch(error){
            if (error.response && error.response.status === 403) {
                handleForbiddenError();
                throw error;
            } else {
                throw error; // Rethrow the error to propagate it
            }
        }
    }


}

/**
 * This is an async function that sends a PATCH request to an API endpoint with a given payload and
 * authentication headers.
 * @param body - The `body` parameter is the data that will be sent in the request body of the PATCH
 * request. It could be an object, an array, or any other data type that can be serialized into JSON.
 * @param endpoint - The endpoint parameter is a string that represents the specific API endpoint that
 * the PATCH request will be sent to. It is typically a URL that specifies the location of the resource
 * that needs to be updated.
 * @returns an object with two properties: "error" and "data". The "error" property is a boolean value
 * indicating whether an error occurred during the API call. The "data" property contains the response
 * data from the API call.
 */
async function PatchAPI(body, endpoint) {
    const status = await CheckUserStatus()
    if (status) {
        try{
            let trimedpayload = trimBody(body);
            const headers = await authHeader()
            const data = await axios.patch(`${baseURL}${endpoint}`, trimedpayload, {
                headers: headers,
            });
            return { error: false, data: data.data };

        }
        catch(error){
            if (error.response && error.response.status === 403) {
                handleForbiddenError();
                throw error;
            }else {
                throw error; // Rethrow the error to propagate it
            }
        }
    }
}

async function PutAPI(body, endpoint) {
    const status = await CheckUserStatus();
    if (status) {
        try {
            let trimmedPayload = trimBody(body);
            const headers = await authHeader();
            const data = await axios.put(`${baseURL}${endpoint}`, trimmedPayload, {
                headers: headers,
            });
            return { error: false, data: data.data };
        } catch (error) {
            if (error.response && error.response.status === 403) {
                handleForbiddenError();
                throw error;
            } else {
                throw error; // Rethrow the error to propagate it
            }
        }
    }
}

/**
 * The function `DeleteAPI` is an asynchronous function that sends a DELETE request to a specified API
 * endpoint using axios and returns the response data.
 * @param endpoint - The `endpoint` parameter is the specific URL or path of the API endpoint that you
 * want to delete. It is appended to the `baseURL` to form the complete URL for the delete request.
 * @returns an object with two properties: "error" and "data". The "error" property is a boolean
 * indicating whether an error occurred during the API call, and the "data" property contains the
 * response data from the API call.
 */
async function DeleteAPI(endpoint) {
    const status = await CheckUserStatus()
    if (status) {
        try{
            const headers = await authHeader()
            const data = await axios.delete(`${baseURL}${endpoint}`, {
                headers: headers,
            });
            return { error: false, data: data };
        }
        catch(error){
            if (error.response && error.response.status === 403) {
                handleForbiddenError();
                throw error;
            } else {
                throw error; // Rethrow the error to propagate it
            }
        }
    }
}

/**
 * The function `appVersion` makes a POST request to an API endpoint with a payload and returns the
 * response data.
 * @param body - The `body` parameter is the payload that will be sent in the request body when making
 * a POST request to the specified URL. It contains the data that you want to send to the server.
 * @returns an object with two properties: "error" and "data". The "error" property is a boolean
 * indicating whether an error occurred during the execution of the function. The "data" property
 * contains the data returned from the API call.
 */
async function appVersion(body) {
    const payload = body;
    const headers = await authHeader()
    const data = await axios.post(`https://8fs3io4nu3.execute-api.ap-south-1.amazonaws.com/dev/list`, payload, {
        headers: headers,
    });
    return { error: false, data: data.data };
}


export const dataService = {
    appVersion,
    PatchAPI,
    GetAPI,
    PostAPI,
    DeleteAPI,
    PutAPI,
}
